<div fxLayout="column" fxLayoutGap="20px" fxFill>

  <fieldset *ngIf="!hasFormErrors">
    <legend>Status do envio ao SIGAD</legend>
    <div fxLayout="column" fxLayoutGap="12px">

      <!-- Inscrições -->
      <div class="sigad-status-line">
        <mat-icon [ngClass]="inscricoesCompletas ? 'icon-success' : (statusInscricoes.permitido ? 'icon-pending' : 'icon-waiting')">
          {{ inscricoesCompletas ? 'check_circle' : (statusInscricoes.permitido ? 'warning' : 'hourglass_empty') }}
        </mat-icon>
        <div>
          <span *ngIf="(statusInscricoes?.total ?? 0) > 0">
            Documentos de inscrição: {{ statusInscricoes.totalCompleto }} de {{ statusInscricoes.total }} enviado(s)
          </span>
          <small class="sigad-status-subtitle" *ngIf="!inscricoesCompletas && !prazoInscricaoEncerrado">
            Aguardando encerramento das inscrições
          </small>
          <small class="sigad-status-subtitle" *ngIf="!inscricoesCompletas && prazoInscricaoEncerrado && temInscricoesAguardandoAnalise">
            Inscrições aguardando análise
          </small>
        </div>
      </div>

      <!-- Declarações -->
      <div class="sigad-status-line" *ngIf="(statusDeclaracoes?.total ?? 0) > 0">
        <mat-icon [ngClass]="declaracoesCompletas ? 'icon-success' : (statusDeclaracoes.permitido ? 'icon-pending' : 'icon-waiting')">
          {{ declaracoesCompletas ? 'check_circle' : (statusDeclaracoes.permitido ? 'warning' : 'hourglass_empty') }}
        </mat-icon>
        <div>
          <span>Declarações da comissão julgadora: {{ statusDeclaracoes.totalCompleto }} de {{ statusDeclaracoes.total }} enviada(s)</span>
          <small class="sigad-status-subtitle" *ngIf="!declaracoesCompletas && !statusDeclaracoes.permitido">
            Aguardando assinatura dos examinadores
          </small>
        </div>
      </div>

      <!-- Resultado Fase 1 -->
      <div class="sigad-status-line">
        <mat-icon [ngClass]="classificacaoFase1Completa ? 'icon-success' : (statusResultadoFase1.permitido ? 'icon-pending' : 'icon-waiting')">
          {{ classificacaoFase1Completa ? 'check_circle' : (statusResultadoFase1.permitido ? 'warning' : 'hourglass_empty') }}
        </mat-icon>
        <div>
          <span>Resultado da Fase 1: {{ statusResultadoFase1.totalCompleto }} de {{ statusResultadoFase1.total }} enviado</span>
          <small class="sigad-status-subtitle" *ngIf="!classificacaoFase1Completa && !statusResultadoFase1.classificacaoConsolidada">
            Aguardando consolidação da classificação
          </small>
        </div>
      </div>
          <small class="sigad-status-subtitle" *ngIf="!classificacaoFase1Completa && statusResultadoFase1.classificacaoConsolidada && statusResultadoFase1.prazoRecursoAtivo">
            Aguardando conclusão de recursos pendentes sobre o resultado da Fase 1
          </small>

      <!-- Resultado Fase 2 -->
      <div class="sigad-status-line">
        <mat-icon [ngClass]="classificacaoFase2Completa ? 'icon-success' : (statusResultadoFase2.permitido ? 'icon-pending' : 'icon-waiting')">
          {{ classificacaoFase2Completa ? 'check_circle' : (statusResultadoFase2.permitido ? 'warning' : 'hourglass_empty') }}
        </mat-icon>
        <div>
          <span>Resultado da Fase 2: {{ statusResultadoFase2.totalCompleto }} de {{ statusResultadoFase2.total }} enviado</span>
          <small class="sigad-status-subtitle" *ngIf="!classificacaoFase2Completa && !statusResultadoFase2.classificacaoConsolidada">
            Aguardando consolidação da classificação
          </small>
        </div>
      </div>

    </div>
  </fieldset>

  <fieldset fxFlex="100%">
    <legend>Atualizar processo digital SIGAD</legend>

    <div
      fxLayoutAlign.gt-md="space-between center"
      fxLayoutAlign.lt-md="center stretch"
      fxLayout.lt-md="column"
      class="button-row"
      fxLayoutGap="20px"
      fxFill>
      <!-- Botão Inscrições -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <button
          mat-raised-button
          color="primary"
          matTooltip="Atualizar no SIGAD informações referentes aos dados de inscrição do concurso"
          (click)="enviarDocs()"
          [disabled]="hasFormErrors || inscricoesCompletas || !statusInscricoes.permitido">
          <mat-icon>update</mat-icon>
          Inscrições
        </button>
        <mat-icon *ngIf="!hasFormErrors && !inscricoesCompletas && statusInscricoes.permitido" class="icon-pending">warning</mat-icon>
      </div>

      <!-- Botão Declarações - Comissão Julgadora -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <button
          mat-raised-button
          color="primary"
          matTooltip="Atualizar com SIGAD informações referentes às declarações de ausência de conflito de interesse dos examinadores da comissão julgadora do concurso"
          (click)="enviarDeclaracoes()"
          [disabled]="hasFormErrors || declaracoesCompletas || !statusDeclaracoes.permitido">
          <mat-icon>update</mat-icon>
          Declarações - Comissão Julgadora
        </button>
        <mat-icon *ngIf="!declaracoesCompletas && statusDeclaracoes.permitido" class="icon-pending">warning</mat-icon>
      </div>

      <!-- Botão Classificação Fase 1 -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <button
          mat-raised-button
          color="primary"
          matTooltip="Atualizar no SIGAD a classificação da Fase 1 do concurso"
          (click)="enviarClassificacaoFase1()"
          [disabled]="
            !statusResultadoFase1.permitido
          ">
          <mat-icon>update</mat-icon>
          Classificação Fase 1
        </button>
        <mat-icon *ngIf="statusResultadoFase1.permitido" class="icon-pending">warning</mat-icon>
      </div>

      <!-- Botão Classificação Fase 2 -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <button
          mat-raised-button
          color="primary"
          matTooltip="Atualizar no SIGAD a classificação da Fase 2 do concurso"
          (click)="enviarClassificacaoFase2()"
          [disabled]="
            !statusResultadoFase2.permitido
          ">
          <mat-icon>update</mat-icon>
          Classificação Fase 2
        </button>
        <mat-icon *ngIf="statusResultadoFase2.permitido" class="icon-pending">warning</mat-icon>
      </div>
    </div>
  </fieldset>
</div>
